import { Component } from '@angular/core';
import { FormFieldSate } from '../form-field.state';

@Component({
  selector: 'app-label-form-field',
  templateUrl: './label-form-field.component.html',
  styleUrls: ['./label-form-field.component.scss'],
})
export class LabelFormFieldComponent extends FormFieldSate {
  public lable: string;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.toggleControl(this.control.value as string);
  }

  public toggleControl(value: string): void {
    this.lable = value;
  }
}
